var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('dashboard-core-app-bar',{attrs:{"DashboardName":_vm.DashBoardName}}),_c('dashboard-core-drawer'),_c('dashboard-core-view'),_c('dashboard-core-settings',{on:{"ChangeDashboardName":_vm.ChangeDashboardName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }